import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CallDashboardComponent } from './call-dashboard/call-dashboard.component';
import { LoginComponent } from './login/login.component';

const routes: Routes = [
  { path: '', component: CallDashboardComponent },
  { path: 'Login', component: LoginComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
